import { createAction, props } from '@ngrx/store'
import { Update } from '@ngrx/entity'
import { MenuDefinition } from './menus.model'

export const loadMenus = createAction(
    '[Menus] Load MegaMenu Updates',
    props<{ menus: MenuDefinition[] }>()
)

export const updateMenuExpansion = createAction(
    '[Menus] Update Menu',
    props<Update<MenuDefinition>>()
)
export const closeMegaMenus = createAction(
    '[Menus] Close Megamenus',
)

export const resetMegaMenus = createAction(
    '[Menus] Reset Megamenus',
)
